import * as persianTools from "@persian-tools/persian-tools";
import { numberToWords } from "@persian-tools/persian-tools";

export default function usePersianTools() {
    const convertPersianToEnglish = (value, obj, key) => {
        if (value && /[۰-۹]/.test(value)) {
            const englishValue = persianTools.digitsFaToEn(value)
            obj[key] = englishValue
            const persianWords = numberToWords(englishValue)
            obj[`${key}_words`] = persianWords
            return englishValue
        } else {
            obj[key] = value
            const persianWords = numberToWords(value)
            obj[`${key}_words`] = persianWords
            return value
        }
    }


    return {
        convertPersianToEnglish
    }
}